import { css } from '@emotion/react'
import { useMemo } from 'react'

import { typo } from '~/@common/styles'
import { mediaQuery } from '~/@common/styles/mediaQuery'
import BarLineChart from '~/@common/ui/BarLineChart/BarLineChart'

const DIFFICULTY_LEVELS: ReadonlyArray<{ level: number; id: string; label: string }> = [
  { level: 1, id: 'difficulty-low', label: '하' },
  { level: 2, id: 'difficulty-low-mid', label: '중하' },
  { level: 3, id: 'difficulty-mid', label: '중' },
  { level: 4, id: 'difficulty-high', label: '상' },
  { level: 5, id: 'difficulty-highest', label: '최상' },
]

type Props = {
  data: ReadonlyArray<{ level: number; problemCount: number; rate: number }>
}

export const DifficultyStatisticsCard = ({ data }: Props) => {
  // 응답에 누락된 level 은 0 으로 채워서 5단계 고정 출력
  const items = useMemo(() => {
    const byLevel = new Map(data.map((d) => [d.level, d]))
    return DIFFICULTY_LEVELS.map(({ level, id, label }) => {
      const found = byLevel.get(level)
      return {
        id,
        label,
        barValue: found?.problemCount ?? 0,
        lineValue: found?.rate ?? 0,
      }
    })
  }, [data])

  return (
    <div css={difficultyStatisticsCardStyle}>
      <h3 className="difficulty-statistics__header">난이도 별 통계</h3>
      <div className="difficulty-statistics__chart">
        <BarLineChart
          data={items}
          barLabel="문제수"
          barUnit="문제"
          lineLabel="정답률"
          lineUnit="%"
          barMaxWidth={24}
        />
      </div>
    </div>
  )
}

const difficultyStatisticsCardStyle = css`
  display: flex;
  flex-direction: column;
  min-width: 384px;
  flex-shrink: 0;
  padding-top: 26px;
  overflow: hidden;
  border-radius: var(--Radius-300);
  background-color: var(--White);

  .difficulty-statistics__header {
    ${typo.body02};
    margin: 0;
    color: var(--Colors-Gray-800);
    text-align: center;
  }

  .difficulty-statistics__chart {
    height: 160px;
    padding: 0 10px;
  }

  ${mediaQuery.underTablet} {
    min-width: unset;
    width: 100%;
  }
`
